import { Button } from '@sleepstation/components'
import { BUTTON_TYPE, LAYOUT_ALIGN, LAYOUT_JUSTIFY } from '@sleepstation/const'
import {
  baseline,
  borderColor,
  mq,
  stylesIfPropTrue,
  themeColor,
} from '@sleepstation/style-api-helpers'
import { mqPointerOnly } from '@sleepstation/style-mixins'
import { defaultAltTheme } from '@sleepstation/themes-public-site'
import { preventWidows } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { prop } from 'ramda'
import React from 'react'
import styled, { ThemeProvider, css } from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(Button).attrs({
  align: LAYOUT_ALIGN.CENTER,
  justify: LAYOUT_JUSTIFY.CENTER,
  kind: BUTTON_TYPE.SECONDARY,
})`
  ${baseline(0.25)}
  min-width: 100%;
  min-height: 100%;
  border-radius: 8px;

  /* Default (white) stars */
  background: url(${prop(`imageUrl`)}),
    ${themeColor(`secondaryBackgroundStart`)};
  background-position: top left;
  background-repeat: repeat-y;
  background-size: 100%;

  /* Highlighted (yellow) stars */
  &::before {
    background: url(${prop(`imageUrlSelected`)}),
      ${themeColor(`secondaryBackgroundStart`)};
    transition: background-image ease-in-out;
    background-position: top left;
    background-repeat: repeat-y;
    background-size: 100%;
  }

  ${stylesIfPropTrue(
    `isSelected`,
    css`
      /* Show the yellow stars */
      &::before {
        opacity: 1;
      }

      /* Show the yellow border */
      &::after {
        border-width: 5px;
        border-style: solid;
        ${borderColor(`highlight`)}
        border-radius: 8px;
      }

      ${mqPointerOnly()} {
        /* Show the yellow border */
        &:enabled:hover::after {
          border-width: 5px;
          border-style: solid;
          ${borderColor(`highlight`)}
        }
      }
    `
  )}

  span {
    max-width: 80%;
    margin: auto;
    ${mq(`smallUp`)} {
      max-width: 100%;
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const InterestsListItem = ({
  title,
  id,
  imageUrl,
  imageUrlSelected,
  isSelected,
  onClick,
}) => (
  <ThemeProvider theme={defaultAltTheme}>
    <Layout
      key={id}
      isSelected={isSelected}
      onClick={onClick}
      imageUrl={imageUrl}
      imageUrlSelected={imageUrlSelected}
    >
      {preventWidows(title)}
    </Layout>
  </ThemeProvider>
)

InterestsListItem.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageUrlSelected: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default InterestsListItem
